import { Avatar, Container, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import QRCodeIcon from '@mui/icons-material/QrCode2Rounded';
import Colors from 'constants/colors';
import MuiLoader from 'components/Common/Loader';

interface ProfileContainer {
    showIcon?: boolean;
    title?: string;
    subtitle?: string;
    imgUrl?: string;
    loading?: boolean;
}

function ParishonerProfileContainer({ showIcon, title, subtitle, imgUrl, loading }: ProfileContainer) {
    return (
        <Container
            sx={{
                py: 3,
                px: 2,
                display: 'flex',
                flexDirection: 'row',
                width: '23rem',
                height: 116,
                backgroundColor: 'white',
                borderRadius: 1,
                alignItems: 'center',
            }}
        >
            {loading ? (
                <MuiLoader loading={loading} />
            ) : (
                <>
                    <Avatar src={imgUrl} variant="square" style={{ width: 78, height: 76 }} />
                    <Stack sx={{ width: '100%', fontSize: 16, fontWeight: 400, color: '#1F2937', ml: 2, flexGrow: 1 }}>
                        <Tooltip title={title}>
                            <Typography className="two-line-text" fontSize={22} fontWeight={500}>
                                {title}
                            </Typography>
                        </Tooltip>
                        <Tooltip title={subtitle}>
                            <Typography
                                style={{ fontSize: 14, width: '90%', whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}
                            >
                                {subtitle ?? 'Username@email.com'}
                            </Typography>
                        </Tooltip>
                    </Stack>
                    {showIcon && (
                        <IconButton sx={{ ml: 1 }}>
                            <QRCodeIcon htmlColor={Colors.darkblue} sx={{ width: 50, height: 50 }} />
                        </IconButton>
                    )}
                </>
            )}
        </Container>
    );
}

export default ParishonerProfileContainer;
